module.exports = "/_next/static/images/soccerActive@3x-e8ddbf32c003cb622dff38069ac65b11.png";